import Stomp from 'stompjs';
import SockJS from 'sockjs-client/dist/sockjs.min.js';
import { tryOnUnmounted } from '@vueuse/core';
import { App, getCurrentInstance } from 'vue';
// import { getToken } from '/@/utils/auth';
import mitt from '/@/utils/mitt';

export declare interface StompClient {
  subscribe(topic: string, callback: (msg: any) => void): void;
  unsubscribe(topic: string): void;
}

export const emitter = mitt();

function createStomp(url: string[]): StompClient[] {
  const clients: StompClient[] = url.map((currentUrl, index) => {
    const subscribes = {};
    let stompClient;
    let socketTimer;

    function _initWebsocket() {
      const socket = new SockJS(currentUrl);
      stompClient = Stomp.over(socket);
      stompClient.debug = null;
      stompClient.connect(
        {
          // Author: '头部信息',
          // Authorization: 'Bearer ' + getToken(),
        },
        () => {
          console.log('stompClient connected!!!', currentUrl);
          emitter.emit('reconnect');
        },
        (err) => {
          console.log('socketErr: ', err);
          if (socketTimer) {
            clearInterval(socketTimer);
          }
          socketTimer = setTimeout(() => {
            console.log('开始重连');
            _initWebsocket();
          }, 10000);
        },
      );
    }
    function _closeWebsocket() {
      console.log('start close websocket connect ...');
      try {
        if (stompClient !== null) {
          stompClient.disconnect(() => {
            console.log('关闭连接');
          });
        }
        if (socketTimer) {
          clearInterval(socketTimer);
        }
      } catch (err) {
        console.error(err);
      }
    }
    function subscribe(topic, callback) {
      if (subscribes[topic]) {
        unsubscribe(topic);
      }
      const subInfo = stompClient.subscribe(topic, (res) => {
        const msg = JSON.parse(res.body);
        callback(msg);
      });
      subscribes[topic] = subInfo;
    }
    function unsubscribe(topic) {
      const subInfo = subscribes[topic];
      if (subInfo) {
        subInfo.unsubscribe();
        delete subscribes[topic];
      }
    }
    function install(app: App) {
      const propKey = `$stompClient${index + 1}`;
      app.config.globalProperties[propKey] = {
        subscribe,
        unsubscribe,
      } as StompClient;
    }
    _initWebsocket();
    tryOnUnmounted(_closeWebsocket);

    return { install };
  });

  return clients;
}

export function setupStomp(app: App, urls: string[]) {
  const stompClients = createStomp(urls);
  stompClients.forEach((client) => {
    app.use(client);
  });
}

// 在 useStompClient 函数中获取动态属性名称
export function useStompClient(index = 1): StompClient {
  const app = getCurrentInstance();
  const propKey = `$stompClient${index}`;
  return app?.appContext.config.globalProperties[propKey];
}
